import axios from "axios";

function _axios() {
	axios.defaults.headers.common['X-Requested-With'] = 'XMLHttpRequest'

	let token = document.head.querySelector('meta[name="csrf-token"]')

	if (token) {
		axios.defaults.headers.common['X-CSRF-TOKEN'] = token.content;
	} else {
		console.error('CSRF token not found: https://laravel.com/docs/csrf#csrf-x-csrf-token')
	}
	return axios
}

function parseAxiosErrorObj(e, _default = 'Something went wrong') {
	let message = e.message || _default;
	if (e.response) {
		// The request was made and the server responded with a status code
		// that falls out of the range of 2xx
		// console.error(e.response.data);
		// console.error(e.response.status);
		// console.error(e.response.headers);
		let data = e.response.data
		let dataMessage = ''

		if (typeof data === 'string') {
			dataMessage = data
		}

		if (data.hasOwnProperty('message')) {
			dataMessage = data.message;
		}
		if (data.hasOwnProperty('errors')) {
			let errors = data.errors;
			dataMessage = dataMessage + '<br>';
			for (let key in errors) {
				if (errors.hasOwnProperty(key)) {
					dataMessage = dataMessage + errors[key] + '<br>';
				}
			}
		}

		message = dataMessage || message

		return message;

	} else if (e.request) {
		// The request was made but no response was received
		// `error.request` is an instance of XMLHttpRequest in the browser and an instance of
		// http.ClientRequest in node.js
		console.error(e.request);

		return message;
	} else {
		// Something happened in setting up the request that triggered an Error
		console.error('Error', e);

		return e.message;
	}
}

export {_axios as default}
export {parseAxiosErrorObj}
